// Autogenerated
// -------------
// gulpfile.js --> generateBuildInfo

export const Build = {
    version: "6.22.30 (a7b59eaf2e131f1b5328a04f3c33a613)",
    jsVersion: "7a9b47b1c3ba95d95d4d2bb58b9248ae603f7479",
    jsSize:  502767,
    wasmVersion: "8ec72e090a255b8554388f6b0d12602c",
    wasmSize: 2297225,
};
